import React from "react";
import './section.css';

function AboutMe (){
    return(
        <div>
            <p><b>Hello, I'm Jakub,</b> a 22-year-old currently residing in the UK, though I was originally born in Poland. 
                I graduated the University of Sheffield with a First-class degree in Computer Science (with a year in industry).  
                I'm now working as a full-time Software Engineer on a postgraduate scheme. <b> This page is very outdated and I'm currently too lazy to update it it all so I'll keep it as is for now.
                Everything you see from here on out was made in like Year 1 of Uni</b></p>
            <p>I have been passionate about Computer Science since I was first introduced to coding through python in Year 9,
                and since then I'm always working on some project be it big or small. 
            </p>
            <div className="section-end-padding"></div>
        </div>
    )
}

export default AboutMe